/**
 * Icon Registry
 * 
 * Central registry for all SVG icons used in the application.
 * Import SVGs as React components using the webpack loader.
 * 
 * Usage:
 * import { icons } from './iconRegistry';
 * import Icon from './Icon';
 * 
 * <Icon component={icons.leftQuote} size="48px" />
 */

// Logo Icons
import { ReactComponent as Logo } from '../../assets/img/logo/logo.svg';

// Quote Icons
import { ReactComponent as LeftQuote } from '../../assets/img/icons/left_quote.svg';
import { ReactComponent as RightQuote } from '../../assets/img/icons/right_quote.svg';

// Navigation Icons
import { ReactComponent as LeftArrow } from '../../assets/img/icons/left-arrow.svg';
import { ReactComponent as UpArrow } from '../../assets/img/icons/up_arrow.svg';
import { ReactComponent as DownArrow } from '../../assets/img/icons/down_arrow2.svg';
import { ReactComponent as RightArrow } from '../../assets/img/icons/RightArrow_3.svg';
import { ReactComponent as Back } from '../../assets/img/auth_onboarding/back.svg';

// Action Icons
import { ReactComponent as Plus } from '../../assets/img/icons/plus.svg';
import { ReactComponent as Minus } from '../../assets/img/icons/minus.svg';
import { ReactComponent as Edit } from '../../assets/img/icons/edit-button.svg';
import { ReactComponent as Delete } from '../../assets/img/icons/delete.svg';
import { ReactComponent as Copy } from '../../assets/img/icons/copy.svg';
import { ReactComponent as Download } from '../../assets/img/icons/download.svg';
import { ReactComponent as Search } from '../../assets/img/icons/search.svg';
import { ReactComponent as Refresh } from '../../assets/img/icons/refresh.svg';

// Status Icons
import { ReactComponent as Tick } from '../../assets/img/icons/tick.svg';
import { ReactComponent as GreenCheck } from '../../assets/img/icons/green_check.svg';
import { ReactComponent as GreyCheck } from '../../assets/img/icons/grey_check.svg';
import { ReactComponent as VioletTick } from '../../assets/img/icons/violet-tick.svg';
import { ReactComponent as CircularCross } from '../../assets/img/icons/circularCross.svg';
import { ReactComponent as Verified } from '../../assets/img/icons/verified.svg';

// Badge Icons
import { ReactComponent as Admin } from '../../assets/img/icons/admin.svg';
import { ReactComponent as Owner } from '../../assets/img/icons/owner.svg';
import { ReactComponent as ManagerBadge } from '../../assets/img/icons/manager_badge.svg';

// Other Icons
import { ReactComponent as BellIcon } from '../../assets/img/icons/bell_Icon.svg';
import { ReactComponent as Trophy } from '../../assets/img/icons/trophy.svg';
import { ReactComponent as Monitor } from '../../assets/img/icons/monitor.svg';
import { ReactComponent as Location } from '../../assets/img/icons/location.svg';
import { ReactComponent as Screenshot } from '../../assets/img/icons/screenshot.svg';

/**
 * Icon Registry Object
 * Add new icons here as they are imported
 */
export const icons = {
  // Logo
  logo: Logo,
  
  // Quotes
  leftQuote: LeftQuote,
  rightQuote: RightQuote,
  
  // Navigation
  leftArrow: LeftArrow,
  upArrow: UpArrow,
  downArrow: DownArrow,
  rightArrow: RightArrow,
  back: Back,
  
  // Actions
  plus: Plus,
  minus: Minus,
  edit: Edit,
  delete: Delete,
  copy: Copy,
  download: Download,
  search: Search,
  refresh: Refresh,
  
  // Status
  tick: Tick,
  greenCheck: GreenCheck,
  greyCheck: GreyCheck,
  violetTick: VioletTick,
  circularCross: CircularCross,
  verified: Verified,
  
  // Badges
  admin: Admin,
  owner: Owner,
  managerBadge: ManagerBadge,
  
  // Other
  bell: BellIcon,
  trophy: Trophy,
  monitor: Monitor,
  location: Location,
  screenshot: Screenshot,
};

/**
 * Helper function to get icon by name
 * @param {string} name - Icon name from the registry
 * @returns {React.Component} - SVG Component
 */
export const getIcon = (name) => {
  return icons[name] || null;
};

export default icons;

